export const FACFormDataTextFormat = (FACFormData) => {
  let FACFormDataFormattedString = "";

  // build string for all keys and values without beneficiaries
  for (let key in FACFormData) {
    if (key !== "beneficiaries") {
      FACFormDataFormattedString += `${key}:${FACFormData[key]}|`;
    }
  }

  // add indexed beneficiaries key:value in string (format: beneficiary-{index}-{key}:{value})
  for (let i = 0; i < FACFormData?.beneficiaries?.length; i++) {
    for (let key in FACFormData?.beneficiaries[i]) {
      FACFormDataFormattedString += `beneficiary-${i}-${key}:${FACFormData?.beneficiaries[i][key]}|`;
    }
  }

  //return final result and remove the last pipe operator
  return FACFormDataFormattedString.substring(
    0,
    FACFormDataFormattedString.length - 1
  );
};
